import { Component } from '@angular/core';

import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-courses-post',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './courses-post.component.html',
})
export class CoursesPostComponent {}
